import React, { useState } from 'react';
import { ChevronDown, ChevronRight, ChevronUp } from 'react-feather';
import { PAGES, ROUTE_PATHS } from '../../../InternalApiApp';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { pluralise } from '../../../Utils/Utils';
import Tooltip from '../../../components/popups/Tooltip';
import "./PortfolioManagement.scss"

const GroupingRow = ({ group, funds, idx, grouping, hierarchy, colWidths }) => {
	const [rowExpanded, setRowExpanded] = useState(false)
	const history = useHistory()

	const fundsList = group?.funds?.map((val) => funds.find((f) => f.id === val))
	const otherGroupings = (hierarchy || []).filter(g => g !== grouping);
	const rowPath = ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/${pluralise(grouping).toLowerCase()}/` + group.groupId;

	const badgedPractice = group?.properties?.badged;
	const selfLicensedPractice = group?.properties?.selfLicensed;

	return (
		<>
			<tr key={idx} className='cursor-pointer' onClick={() => history.push(rowPath)}>
				<td className={rowExpanded ? "expanded-table-row" : ""}>
					{group.groupName}
					{badgedPractice && <Tooltip label="Badged Practice"><i className='material-symbols-outlined' style={{ verticalAlign: 'middle', color: '#06467D'}}>license</i></Tooltip>}
					{selfLicensedPractice && <Tooltip label="Self Licensed"><i className='material-symbols-outlined' style={{ verticalAlign: 'middle', color: '#996633'}}>license</i></Tooltip>}
				</td>
				<td className={rowExpanded ? "expanded-table-row" : ""}>{group.product}</td>
				<td className={rowExpanded ? "expanded-table-row" : ""}>{group?.funds?.length}</td>
				<td className={rowExpanded ? "expanded-table-row" : ""}>
					<div style={{ display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'right' }}>
						{rowExpanded ?
							<ChevronUp className='colour-text-primary' size={24} onClick={(e) => { e.stopPropagation(); setRowExpanded(false) }} /> :
							<ChevronDown className='colour-text-neutral-dark-30' size={24} onClick={(e) => { e.stopPropagation(); setRowExpanded(true) }} />
						}
					</div>
				</td>
			</tr>
			{rowExpanded &&
				<table className='managers-row-nested-table' style={{ maxWidth: 1200, width: 1200 }}>
					{colWidths && (
						<colgroup>
							{colWidths.map((width, idx) => (
								<col key={"col-" + idx} span="1" style={{ width }} />
							))}
						</colgroup>
					)}
					<thead>
						<tr>
							<th className="nested-table-empty-th" colSpan={2}><div className="nested-table-div-in-td no-top left-xxl">Portfolio Name</div></th>
							<th className="nested-table-empty-th"><div className="nested-table-div-in-td no-top">Code</div></th>
							<th className="nested-table-empty-th"><div className="nested-table-div-in-td no-top">Platform</div></th>
							{otherGroupings.map(g => (
								<th key={g} className="nested-table-empty-th"><div className="nested-table-div-in-td no-top">{g}</div></th>
							))}
							<th className="nested-table-empty-th no-border"><div>&nbsp;</div></th>
							<th className="nested-table-empty-th no-border"><div>&nbsp;</div></th>
						</tr>
					</thead>
					<tbody>
						{fundsList?.map((f, index) => f && (
							<tr key={f.id + "-funds-expanded-" + index} className='cursor-pointer managers-row-nested-row'>
								<td className="nested-table-empty-td" colSpan={2}><div className="nested-table-div-in-td left-xxl">{f.fundName}</div></td>
								<td className="nested-table-empty-td"><div className="nested-table-div-in-td">{f.fundNumber}</div></td>
								<td className="nested-table-empty-td"><div className="nested-table-div-in-td">{f.schemeName}</div></td>
								{otherGroupings.map(g => (
									<td key={g} className="nested-table-empty-td"><div className="nested-table-div-in-td">{typeof f.groupings?.[g] === "string" ? f.groupings[g] : "-"}</div></td>
								))}
								<td className="nested-table-empty-td">
									<div className="nested-table-div-in-td" style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
										<ChevronRight className='colour-text-primary' size={16} onClick={(e) => { e.stopPropagation(); history.push(ROUTE_PATHS[PAGES.ADMIN] + '/portfolio-management/portfolios/' + f.fundNumber) }} />
									</div>
								</td>
								<td className="nested-table-empty-td no-border"><div>&nbsp;</div></td>
							</tr>
						))}
						<tr>
							<td className="nested-table-empty-td" colSpan={2}><div className="nested-table-div-in-td left-xxl">&nbsp;</div></td>
							<td className="nested-table-empty-td"><div className="nested-table-div-in-td">&nbsp;</div></td>
							<td className="nested-table-empty-td no-border"><div className="nested-table-div-in-td">&nbsp;</div></td>
							<td className="nested-table-empty-td no-border"><div>&nbsp;</div></td>
						</tr>
					</tbody>
				</table>
			}
		</>
	)
}

export default GroupingRow;
